import { render, staticRenderFns } from "./dynamicSelect.vue?vue&type=template&id=47abb0d7"
import script from "./dynamicSelect.vue?vue&type=script&lang=js"
export * from "./dynamicSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports